var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('span',{staticClass:"collect-delay-days-chip",attrs:{"title":_vm.label}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }